<template>
    <div>
        <modal class="task-tutorial" :display="modalStatus.taskTutorial" @modalStatus="closeModal" >
            <h1>委託說明</h1>
            <div class="task-tutorial-wrap">
                <carousel  :value="0" :navigateTo="0" :perPage="1" :navigationNextLabel="nextLabel" :navigationPrevLabel="prevLabel" :navigationEnabled="true">
                    <slide>
                        <img class="steps" src="@/assets/img/pages/task/step1.png" alt="" srcset="">
                        <div class="perspective">房東 app 畫面示意</div>
                        <div class="description">
                            <span class="dot">1</span>
                            點選右上角 + 新增一筆委託<br>給租約即將到期的房客
                        </div>
                    </slide>
                    <slide>
                        <img class="steps" src="@/assets/img/pages/task/step2.png" alt="" srcset="">
                        <div class="perspective">房客 app 畫面示意</div>
                        <div class="description">
                            <span class="dot">2</span>
                            您的房客會在房東委託中<br>收到委託通知
                        </div>
                    </slide>
                    <slide>
                        <img class="steps" src="@/assets/img/pages/task/step3.png" alt="" srcset="">
                        <div class="perspective">房東 app 畫面示意</div>
                        <div class="description">
                            <span class="dot">3</span>
                            房客掃描看屋人QR CODE<br>房東能即時掌握帶看狀況
                        </div>
                    </slide>
                    <slide>
                        <img class="steps" src="@/assets/img/pages/task/step4.png" alt="" srcset="">
                        <div class="perspective">房客 app 畫面示意</div>
                        <div class="description">
                            <span class="dot">4</span>
                            新房客線上簽約後，飛豬撥發<br>委託獎金給原房客，完成本次委託
                        </div>
                        <div class="insert-task">
                            <router-link :to="{ name: 'NewTask'}" >
                                <img src="@/assets/img/icon/plus_white.svg" alt="">
                                新增委託
                            </router-link>
                        </div>
                    </slide>
                </carousel>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { Carousel, Slide } from 'vue-carousel';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            prevLabel: "<img src='"+require('@/assets/img/icon/arrow_left_gray.svg')+"' />",
            nextLabel: "<img src='"+require('@/assets/img/icon/arrow_right_gray.svg')+"' />",
        }
    },
    // mounted() {
    //     this.$analytics.logEvent('帳單明細', { screen_name: '帳單明細'})
    // },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'taskTutorial'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        Carousel,
        Slide
    }
}
</script>
<style lang="scss"  >
    #modal.task-tutorial{
        .modal-content{
            width: 448px;
            height: 600px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    width: 320px;
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto 0px;
                    line-height: 1.5;
                }
                .task-tutorial-wrap{
                    width: 315px;
                    padding: 24px 52px;
                    margin: 0 auto;
                    .VueCarousel{
                        .VueCarousel-wrapper{
                            .VueCarousel-slide{
                                display: flex;
                                align-items: center;
                                justify-content: flex-start;
                                flex-direction: column;
                                .steps{
                                    width: 315px;
                                    margin-bottom: 20px;
                                }
                                .perspective{
                                    width: 118px;
                                    padding: 5px 10px;
                                    border-radius: 2px;
                                    border: solid 1px #ff9275;
                                    background-color: #ffffff;
                                    color: #ff9275;
                                    margin-bottom: 20px;
                                }
                                .description{
                                    display: flex;
                                    align-items: flex-start;
                                    font-size: 16px;
                                    font-weight: 500;
                                    line-height: 1.5;
                                    .dot{
                                        position: relative;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        top: 3px;
                                        width: 20px;
                                        height: 20px;
                                        background-color: #ff9275;
                                        border-radius: 50%;
                                        color: #fff;
                                        font-size: 12px;
                                        margin-right: 6px;
                                        font-weight: 300;
                                    }
                                }
                                .insert-task{
                                    width: 92px;
                                    cursor: pointer;
                                    border-radius: 4px;
                                    background-color: #ff9275;
                                    padding: 0 14px;
                                    margin-top: 20px;
                                    a{
                                        height: 44px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        color: #fff;
                                    }
                                }
                            }
                        }
                        .VueCarousel-navigation{
                            .VueCarousel-navigation--disabled{
                                display: none !important;
                            }
                            .VueCarousel-navigation-button{
                                outline: none;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                opacity: 1;
                                top: 130px;
                            }
                        }
                        
                        .VueCarousel-pagination{
                            position: absolute;
                            bottom: -51px;
                            .VueCarousel-dot-container{
                                margin-top: 13px;
                                .VueCarousel-dot{
                                    outline: none;
                                    width: 6px !important;
                                    height: 6px !important;
                                    background-color: #e1e1e1 !important;
                                    padding: 5px !important;
                                }
                                .VueCarousel-dot--active{
                                    width: 6px !important;
                                    height: 6px !important;
                                    border-radius: 10px !important;
                                    background-color: #ff9275 !important;
                                }
                            }
                        }
                    }
                }
            }
      
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/modal/taskTutorial.vue